import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { useAppState } from '../contexts/appState';
import { NonLoginHome, Shimmer } from '../components';
import { getSourceValue } from '../lib/common';
import useAlert from '../hooks/useAlert';

export const JD_PARTNER_OPTIONS = [
  { id: 'self', title: 'Self', icon: 'type_business_icon', faqKey: 'jdPartner' },
  { id: 'client', title: 'Client', icon: 'type_user_icon', faqKey: 'jdPartnerClient' },
];

export default function JdPartner() {
  const navigate = useNavigate();
  const [authState] = useAuth();
  const [appState] = useAppState();
  const [setAlert] = useAlert();
  const { loader } = appState;
  const { sidResponse, userDetails } = authState;
  const source = getSourceValue();

  useEffect(() => {
    if (sidResponse && !loader && !userDetails?.jdPartnerEligible) {
      setAlert({ message: 'This contract is not applicable for JD Partner', status: false });
      navigate('/csportal');
    }
  }, [sidResponse, loader, userDetails?.jdPartnerEligible]);

  if (loader) {
    return <Shimmer />;
  }

  if (!sidResponse) {
    return null;
  }

  if (!userDetails?.jdPartnerEligible) {
    return null;
  }

  const handleSelect = (each) => {
    sessionStorage.setItem('jdPartnerType', each?.id || '');
    if (each?.id === 'client') {
      window.location.href = `/genio?token=${userDetails?.token || ''}`;
      return;
    }
    navigate(`/csportal/faq/${each?.faqKey || ''}?source=${source}`);
  };

  return <NonLoginHome options={JD_PARTNER_OPTIONS} onSelect={handleSelect} />;
}
